import { render, staticRenderFns } from "./goodsBuyerVisitLog.vue?vue&type=template&id=24c8c470&"
import script from "./goodsBuyerVisitLog.vue?vue&type=script&lang=js&"
export * from "./goodsBuyerVisitLog.vue?vue&type=script&lang=js&"
import style0 from "./goodsBuyerVisitLog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports